import React from 'react';
import {Box, Img} from '@chakra-ui/react';
import HeroSvg from '../../../assets/images/podcasts-hero.svg';
import HeroSmallSvg from '../../../assets/images/podcasts-hero.svg';
import OuterHeroSvg from '../../../assets/images/outer-join-hero.svg';
import Container from "../../../components/Container";
import {useLocation} from 'react-router-dom';

const PortfolioHero = () => {
    const location = useLocation();
    const podcast = location.pathname.indexOf("the-outer-join") != -1 ? 'the-outer-join' : "running-through-walls";
    return (
        <>
            <Box
                pt={{base: '42px', md: '75px'}}
                pb={{base: '79px', md: '133px'}}
                borderX={'1px'}
                borderColor={'brandAlpha.200'}
            >
                <Container>
                    <Box
                        position={'relative'}
                        display={'flex'}
                        justifyContent={{base: 'start', md: 'center'}}
                    >
                        {podcast == 'the-outer-join' ? 
                            <>
                                <Img
                                    display={{base: 'none', md: 'block'}}
                                    src={OuterHeroSvg}
                                    alt="companies-hero"
                                    maxHeight={'135px'}
                                    marginRight={'5%'}
                                />
                                <Img
                                    display={{base: 'block', md: 'none'}}
                                    src={OuterHeroSvg}
                                    alt="companies-hero-small"
                                />
                            </>
                            :
                            <>
                                <Img
                                    display={{base: 'none', md: 'block'}}
                                    src={HeroSvg}
                                    alt="companies-hero"
                                    maxHeight={'250px'}
                                    marginRight={'5%'}
                                />
                                <Img
                                    display={{base: 'block', md: 'none'}}
                                    src={HeroSmallSvg}
                                    alt="companies-hero-small"
                                />
                            </>
                        }       
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default PortfolioHero;
